<template>
<div>
  <div class="horizontal">
    <div class="left">借入先</div>
    <div class="right">
      <table class="table-connection">
        <thead>
          <tr>
            <th>借入先名</th>
            <th>用途</th>
            <th>残高</th>
            <th>年間返済額</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(borrower, index) in item.data.borrowers"
            :index="index">
            <th>{{ borrower.name }}</th>
            <td>{{ borrower.howUse }}</td>
            <td>{{ borrower.amount }}万円</td>
            <td>{{ borrower.repaymentAtYear }}万円</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
